import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scheduleType", "dayOfWeek", "dayOfMonth", "processHandling", "existingProcessOptions"]

  connect() {
    this.update()
  }

  update() {
    const type = this.hasScheduleTypeTarget ? this.scheduleTypeTarget.value : null
    this.toggleTarget("dayOfWeek", type === "weekly")
    this.toggleTarget("dayOfMonth", type === "monthly")

    const checkedHandling = this.processHandlingTargets.find((el) => el.checked)
    const handling = checkedHandling ? checkedHandling.value : null
    this.toggleTarget("existingProcessOptions", handling === "apply_to_open_processes")
  }

  toggleTarget(targetName, shouldShow) {
    const hasTarget = this[`has${this.capitalize(targetName)}Target`]
    if (!hasTarget) return
    const target = this[`${targetName}Target`]
    target.style.display = shouldShow ? "" : "none"
  }

  capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1)
  }
}
